import { useEffect } from "react";

// Timetables show 00:00–24:00. On open (and when the period changes) scroll
// the grid to one hour before the earliest lesson shown, or to 08:00 when
// there is none — otherwise phones always open on empty night hours.
export default function useTimelineStartScroll(canvasRef, hourWidth, deps) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !hourWidth) return undefined;
    const frame = requestAnimationFrame(() => {
      const starts = [...canvas.querySelectorAll(".admin-timetable__event")]
        .map((el) => parseFloat(el.style.insetInlineStart))
        .filter((n) => Number.isFinite(n));
      const offset = starts.length ? Math.min(...starts) : 8 * hourWidth;
      const target = Math.max(0, offset - hourWidth);
      // RTL scroll positions are negative in modern browsers.
      const rtl = getComputedStyle(canvas).direction === "rtl";
      canvas.scrollLeft = rtl ? -target : target;
    });
    return () => cancelAnimationFrame(frame);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef, hourWidth, ...deps]);
}
